// import { useState, useEffect } from "react";
// import { Plus, Pencil, Trash2 } from "lucide-react";
// import AddBannerModal from "./BannerModal";
// import toast from "react-hot-toast";
// import SummaryApi from "../common/SummaryApi";
// import api from "../common/apiClient";
// import PageLoader from "../helpers/PageLoader";

// const HomeBanner = () => {
//   const [open, setOpen] = useState(false);
//   const [editData, setEditData] = useState(null);
//   const [deleteId, setDeleteId] = useState(null);
//   const [banners, setBanners] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const openEdit = (banner) => {
//     setEditData(banner);
//     setOpen(true);
//   };

//   const openAdd = () => {
//     setEditData(null);
//     setOpen(true);
//   };

//   // Fetch banners
//   const fetchBanners = async () => {
//     setLoading(true);
//     try {
//       const res = await api({
//         url: SummaryApi.getAllBanners.url,
//         method: SummaryApi.getAllBanners.method,
//       });

//       const data = res.data?.data || [];

//       const mapped = data.map((b) => ({
//         id: b._id,
//         _id: b._id,
//         image: b.image,
//         title: b.title,
//         placement: b.placement,
//         status: b.status,
//       }));

//       setBanners(mapped);
//     } catch (err) {
//       console.error("Banner fetch error:", err);
//       toast.error("Failed to load banners");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchBanners();
//   }, []);

//   // Toggle status
//   const toggleStatus = async (banner) => {
//     try {
//       const formData = new FormData();
//       formData.append("title", banner.title);
//       formData.append("placement", banner.placement);
//       formData.append("status", !banner.status);

//       // important fix
//       if (banner.image?.url) {
//         formData.append("imageUrl", banner.image.url);
//       }

//       await api({
//         url: SummaryApi.updateBanner.url(banner._id),
//         method: SummaryApi.updateBanner.method,
//         data: formData,
//       });

//       setBanners((prev) =>
//         prev.map((b) =>
//           b._id === banner._id ? { ...b, status: !b.status } : b
//         )
//       );

//       toast.success("Banner updated");
//     } catch (error) {
//       console.error(error);
//       toast.error("Update failed");
//     }
//   };

//   // Delete banner
//   const confirmDelete = async () => {
//     try {
//       await api({
//         url: SummaryApi.deleteBanner.url(deleteId),
//         method: SummaryApi.deleteBanner.method,
//       });

//       setBanners((prev) => prev.filter((b) => b._id !== deleteId));

//       toast.success("Banner deleted successfully");
//       setDeleteId(null);
//     } catch (error) {
//       console.error(error);
//       toast.error("Delete failed");
//     }
//   };

//   if (loading) {
//     return (
//       <PageLoader />
//     );
//   }

//   return (
//     <div className="p-2">
//       {/* Header */}
//       <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
//         <h1 className="text-2xl md:text-3xl font-medium font-times">
//           Home Banner
//         </h1>

//         <button
//           onClick={openAdd}
//           className="flex items-center gap-2 bg-[#45A301] text-white px-4 py-2 rounded-lg text-sm transition"
//         >
//           <Plus size={18} />
//           Add Banner
//         </button>
//       </div>

//       {/* Table */}
//       <div className="bg-white rounded-xl border overflow-hidden">
//         <div className="overflow-x-auto">
//           <div className="min-w-[700px] grid grid-cols-5 px-6 py-4 bg-gray-50 text-sm font-medium">
//             <div>Banner Preview</div>
//             <div>Title</div>
//             <div>Placement</div>
//             <div>Status</div>
//             <div className="text-right">Actions</div>
//           </div>

//           {banners.map((banner) => (
//             <div
//               key={banner._id}
//               className={`min-w-[700px] grid grid-cols-5 items-center px-6 py-5 border-t ${
//                 !banner.status ? "opacity-50" : "opacity-100"
//               }`}
//             >
//               <img
//                 src={banner.image?.url || banner.image}
//                 className="w-28 h-14 rounded-md object-cover"
//                 alt={banner.title}
//               />

//               <div className="truncate">{banner.title}</div>

//               <div>
//                 <span className="text-xs bg-[#ECFDF5] text-[#45A301] px-3 py-1 rounded-full">
//                   {banner.placement}
//                 </span>
//               </div>

//               <div>
//                 <div
//                   onClick={() => toggleStatus(banner)}
//                   className={`w-10 h-5 rounded-full relative cursor-pointer ${
//                     banner.status ? "bg-[#45A301]" : "bg-gray-400"
//                   }`}
//                 >
//                   <div
//                     className={`absolute top-1 w-3 h-3 bg-white rounded-full ${
//                       banner.status ? "right-1" : "left-1"
//                     }`}
//                   />
//                 </div>
//               </div>

//               <div className="flex justify-end gap-4">
//                 <Pencil
//                   size={18}
//                   className="cursor-pointer hover:text-blue-600"
//                   onClick={() => openEdit(banner)}
//                 />

//                 <Trash2
//                   size={18}
//                   className="cursor-pointer hover:text-red-600"
//                   onClick={() => setDeleteId(banner._id)}
//                 />
//               </div>
//             </div>
//           ))}

//           {banners.length === 0 && (
//             <div className="p-6 text-center text-gray-500">
//               No banners available. Click "Add Banner"
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Add / Edit Modal */}
//       {open && (
//         <AddBannerModal
//           close={() => setOpen(false)}
//           editData={editData}
//           refresh={fetchBanners}
//         />
//       )}

//       {/* Delete Modal */}
//       {deleteId && (
//         <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999]">
//           <div className="bg-white p-6 rounded-xl w-[300px] shadow-lg">
//             <h2 className="text-lg font-semibold mb-2">Confirm Delete</h2>

//             <p className="text-sm text-gray-500 mb-5">
//               Are you sure you want to delete this banner?
//             </p>

//             <div className="flex justify-end gap-3">
//               <button
//                 onClick={() => setDeleteId(null)}
//                 className="px-4 py-2 border rounded-md text-sm"
//               >
//                 Cancel
//               </button>

//               <button
//                 onClick={confirmDelete}
//                 className="px-4 py-2 bg-red-500 text-white rounded-md text-sm"
//               >
//                 Delete
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// export default HomeBanner;

import { useState, useEffect } from "react";
import { Plus, Pencil, Trash2, Loader2 } from "lucide-react"; // Added Loader2
import AddBannerModal from "./BannerModal";
import toast from "react-hot-toast";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";
import PageLoader from "../helpers/PageLoader";

const HomeBanner = () => {
  const [open, setOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  
  // NEW: Loading states for actions
  const [isDeleting, setIsDeleting] = useState(false);
  const [statusProcessingId, setStatusProcessingId] = useState(null);

  const openEdit = (banner) => {
    setEditData(banner);
    setOpen(true);
  };

  const openAdd = () => {
    setEditData(null);
    setOpen(true);
  };

  const fetchBanners = async () => {
    setLoading(true);
    try {
      const res = await api({
        url: SummaryApi.getAllBanners.url,
        method: SummaryApi.getAllBanners.method,
      });
      const data = res.data?.data || [];
      setBanners(data.map((b) => ({
        id: b._id,
        _id: b._id,
        image: b.image,
        title: b.title,
        placement: b.placement,
        status: b.status,
      })));
    } catch (err) {
      toast.error("Failed to load banners");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const toggleStatus = async (banner) => {
    setStatusProcessingId(banner._id); // Start processing for this specific ID
    try {
      const formData = new FormData();
      formData.append("title", banner.title);
      formData.append("placement", banner.placement);
      formData.append("status", !banner.status);

      if (banner.image?.url) {
        formData.append("imageUrl", banner.image.url);
      }

      await api({
        url: SummaryApi.updateBanner.url(banner._id),
        method: SummaryApi.updateBanner.method,
        data: formData,
      });

      setBanners((prev) =>
        prev.map((b) => b._id === banner._id ? { ...b, status: !b.status } : b)
      );
      toast.success("Status updated");
    } catch (error) {
      toast.error("Update failed");
    } finally {
      setStatusProcessingId(null); // End processing
    }
  };

  const confirmDelete = async () => {
    setIsDeleting(true); // Start delete loading
    try {
      await api({
        url: SummaryApi.deleteBanner.url(deleteId),
        method: SummaryApi.deleteBanner.method,
      });
      setBanners((prev) => prev.filter((b) => b._id !== deleteId));
      toast.success("Banner deleted successfully");
      setDeleteId(null);
    } catch (error) {
      toast.error("Delete failed");
    } finally {
      setIsDeleting(false); // End delete loading
    }
  };

  if (loading) return <PageLoader />;

  return (
    <div>
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-4 mb-6">
        <h1 className="text-2xl md:text-3xl font-medium font-times text-gray-800">Home Banner</h1>
        <button onClick={openAdd} className="flex items-center gap-2 bg-[#45A301] text-white px-4 py-2 rounded-lg text-sm hover:bg-[#3a8a01] transition">
          <Plus size={18} /> Add Banner
        </button>
      </div>

      <div className="bg-white rounded-xl border overflow-hidden">
        <div className="overflow-x-auto">
          <div className="min-w-[700px] grid grid-cols-5 px-6 py-4 bg-gray-50 text-sm font-medium text-gray-600">
            <div>Banner Preview</div>
            <div>Title</div>
            <div>Placement</div>
            <div>Status</div>
            <div className="text-right">Actions</div>
          </div>

          {banners.map((banner) => (
            <div key={banner._id} className={`min-w-[700px] grid grid-cols-5 items-center px-6 py-5 border-t ${!banner.status ? "opacity-60" : "opacity-100"}`}>
              <img src={banner.image?.url || banner.image} className="w-28 h-14 rounded-md object-cover bg-gray-100" alt={banner.title} />
              <div className="truncate pr-4">{banner.title}</div>
              <div><span className="text-xs bg-[#ECFDF5] text-[#45A301] px-3 py-1 rounded-full">{banner.placement}</span></div>
              
              <div>
                <button
                  disabled={statusProcessingId === banner._id}
                  onClick={() => toggleStatus(banner)}
                  className={`w-10 h-5 rounded-full relative transition-all ${banner.status ? "bg-[#45A301]" : "bg-gray-400"} ${statusProcessingId === banner._id ? "opacity-50 cursor-not-allowed" : "cursor-pointer"}`}
                >
                  <div className={`absolute top-1 w-3 h-3 bg-white rounded-full transition-all ${banner.status ? "right-1" : "left-1"}`} />
                </button>
              </div>

              <div className="flex justify-end gap-4">
                <button onClick={() => openEdit(banner)} className="p-1 hover:text-blue-600"><Pencil size={18} /></button>
                <button onClick={() => setDeleteId(banner._id)} className="p-1 hover:text-red-600"><Trash2 size={18} /></button>
              </div>
            </div>
          ))}

          {banners.length === 0 && <div className="p-10 text-center text-gray-500">No banners found.</div>}
        </div>
      </div>

      {open && <AddBannerModal close={() => setOpen(false)} editData={editData} refresh={fetchBanners} />}

      {/* Delete Modal with Loading */}
      {deleteId && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-[9999] p-4 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-xl w-full max-w-sm shadow-xl animate-in fade-in zoom-in duration-200">
            <h2 className="text-lg font-bold text-gray-800">Confirm Delete</h2>
            <p className="text-sm text-gray-500 my-4">Are you sure you want to delete this banner? This action cannot be undone.</p>
            <div className="flex justify-end gap-3 border-t pt-4">
              <button disabled={isDeleting} onClick={() => setDeleteId(null)} className="px-4 py-2 border rounded-md text-sm font-medium hover:bg-gray-50 disabled:opacity-50">Cancel</button>
              <button 
                disabled={isDeleting} 
                onClick={confirmDelete} 
                className="px-6 py-2 bg-red-600 text-white rounded-md text-sm font-medium hover:bg-red-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isDeleting ? <><Loader2 size={14} className="animate-spin" /> Deleting...</> : "Delete Banner"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default HomeBanner;